import { render } from "./ManufacturerView.vue?vue&type=template&id=6d54defa&scoped=true"
import script from "./ManufacturerView.vue?vue&type=script&lang=js"
export * from "./ManufacturerView.vue?vue&type=script&lang=js"

import "./ManufacturerView.vue?vue&type=style&index=0&id=6d54defa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d54defa"]])

export default __exports__